// extracted by mini-css-extract-plugin
module.exports = {"nav":"_8e84fa7","navList":"_7861591","navItem":"_38b7d2a","navItemActive":"_07b6eaa","arrowButton":"_706cb8c","collapsed":"_3139df7"};